import BaseMixin from "./BaseMixin"
import { get } from 'lodash-es'

export default {
  mixins: [BaseMixin],
  methods: {
      crudAtivar(id, options){
        this._validate()
        return this.$axios.$put(`${this.pathApi}/${id}/ativar`, options)
          .then(() => {
            this.$notify({
              type: 'success',
              title: this.$t("msg.sucesso"),
              message: this.$tc(
                "msg.item_removido_ativado",
                this.$t("msg.item_removido_ativado.ativado")
              )
            });
          })
          .catch((err) => {
            console.error( err)
            const erro = get(err, 'response.data.message')
            this.$notify({
              title: this.$t('title.erro'),
              message: this.$t('erro.' + erro),
              type: 'error'
            })
          });
      }
  }
}
